import ObjectUtils from "../../../components/UserInterfaces/mixins/object-utils";

export default {
    mixins: [ObjectUtils],
    methods: {
        __generateDataAndSaveModel() {
            const newSave = {};
            const addPathValue = (key, path, saveModel) => {
                let searchModel = saveModel;
                const attributes = path.split(".");
                const [last] = attributes.splice(-1);

                attributes.forEach(attribute => {
                    if (!searchModel.hasOwnProperty(attribute)) {
                        searchModel[attribute] = {};
                    }
                    searchModel = searchModel[attribute];
                });

                Object.defineProperty(searchModel, last, { enumerable: true, get: () => this.data[key].value });
            };
            const getPathValue = (path, dataModel) => {
                let searchModel = dataModel;
                const attributes = path.split(".");
                let loop = 0; const
                    max = attributes.length;

                while (loop < max && searchModel) {
                    if (searchModel.hasOwnProperty(attributes[loop])) {
                        searchModel = searchModel[attributes[loop]];
                    } else {
                        searchModel = null;
                    }
                    loop++;
                }

                return searchModel;
            };

            this.setData(this.__generateData(this.body, 0));
            Object.entries(this.properties).forEach(([key, data]) => {
                if (data.set) {
                    addPathValue(key, data.set, newSave);
                }
                if (data.get) {
                    this.data[key].value = getPathValue(data.get, this.loadedData);
                }
            });

            this.save = newSave;
        }
    }
};
